import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
// import { useInView } from 'react-intersection-observer'

import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { ExploreButton } from './ExploreButton'
import { SomniumAnimation } from './SomniumAnimation'


import styles from './styles.module.scss'

interface IProps {
}


const ExploreSection: FC<IProps> = props => {
  // const { ref: middleBlockRef, inView, entry } = useInView({
  //   threshold: 0.1
  // })


  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.exploreContainer}>
          <TitleSection title={'Explore Ownership and Security'}
                        subTitle={'Empowering Your Virtual World'}/>

          <div className={styles.middleBlock}>
            <div className={styles.descriptionBox}>
              In Somnium Space, the world you create and the treasures you obtain by selling your arts and crafts are
              truly yours. Our cutting-edge blockchain technology ensures that the items you possess and the experiences
              you craft are securely owned by you. With every step you take, you're walking in a metaverse that values
              you, your creative spirit and also respects your ownership rights.
              <br/><br/>
              <div className={styles.descriptionSubtitle}>Experience True Ownership:</div>
              Dive into a world where Ethereum blockchain ensures genuine ownership of your virtual assets.
              <br/><br/>
              <div className={styles.descriptionSubtitle}>Revolutionizing VR Interaction:</div>
              Immerse yourself in dynamic social experiences,
              powered by cutting-edge technology.
              <br/><br/>
              <div className={styles.descriptionSubtitle}>Decentralized Trades Await:</div>
              Engage in secure trades through decentralized
              marketplaces in our virtual realm.
            </div>

            <SomniumAnimation/>
            {/*{inView*/}
            {/*  ? <SomniumAnimation/>*/}
            {/*  : <img src={staticMultimedia.explore} alt="explore"*/}
            {/*         className={styles.marketplaceImg}/>*/}
            {/*}*/}

          </div>

          <div className={styles.bottomBlock}>
            <TitleBottomSection title={'Explore Somnium $CUBEs: Your Gateway to the Metaverse Economy'}
                                subTitle={'Discover a new dimension of ownership and trade. Dive into our immersive blockchain-driven ecosystem with Somnium Cubes. Use them on renowned marketplaces like OpenSea, or find them in exchanges like Gemini, Uniswap, and explore the future of virtual assets. For a deeper understanding, you can download our Sominum Economy Paper.'}/>
            <div className={styles.rightBox}>
              <div>
                <ExploreButton styleType={'opensea'}/>
                <ExploreButton styleType={'uniswap'}/>
              </div>
              <div>
                <ExploreButton styleType={'gemini'}/>
                <ExploreButton styleType={'economy'}/>
              </div>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(ExploreSection)
